export const Utils =
{
    methods:
    {
        isAuthenticated()
        {
            return (this.$store.state.name !== "");
        },
        isAdmin()
        {
            return (this.$store.state.isAdmin);
        },
        getCustomers()
        {
            return (this.$store.state.customers);
        },
        getPharmacies()
        {
            return (this.$store.state.pharmacies);
        },
        getFolders()
        {
            return (this.$store.state.folders);
        },
        getCustomerId(name)
        {
            const customers = this.$store.state.customers;
            for (let customer of customers)
            {
                if (customer.customername === name)
                {
                    return customer.id;
                }
            }
        },
        getPharmacyId(name)
        {
            const pharmacies = this.$store.state.pharmacies;
            for (let pharmacy of pharmacies)
            {
                if (pharmacy.name === name)
                {
                    return pharmacy.id;
                }
            }
        },
        getPharmacyName(id)
        {
            const pharmacies = this.$store.state.pharmacies;
            for (let pharmacy of pharmacies)
            {
                if (pharmacy.id == id)
                {
                    return pharmacy.name;
                }
            }
        },
        getCountries()
        {   
            const countries = this.$store.state.countries;
            let ret = [];
            for (let country of Object.entries(countries))
            {
                ret.push({code: parseInt(country[0]), value:country[1]})
            }
            return ret;
        }
    }
};